export default __webpack_public_path__ + "static/media/Substitute_In_Future.04d0708c.png";